import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';
import { forwardRef } from 'react';
import { CssTextField } from 'yoda-ui/components/Form/TextField/TextField.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TextFieldProps = Omit<MuiTextFieldProps, 'variant' | 'InputLabelProps'> & {
  variant?: 'outlined' | 'filled' | 'standard';
  InputLabelProps?: Record<string, unknown>;
};

const TextField = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  const { InputLabelProps, variant = 'outlined', ...otherProps } = props;
  return (
    <MuiTextField
      ref={ ref }
      variant={ variant }
      InputLabelProps={ { ...InputLabelProps, shrink: true } as MuiTextFieldProps['InputLabelProps'] }
      { ...otherProps as MuiTextFieldProps }
      sx={ { ...CssTextField, ...otherProps.sx } }
    />
  );
});

TextField.displayName = 'TextField';

export default TextField;
